export enum Gravite {
    MINEURE = 'Mineure',
    MAJEURE = 'Majeure',
    GRAVE = 'Grave'
}
